import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 首页配置数据(接口数据)
export const setWebsiteHomeConfigs: Mutation<IModuleState> = (state, payload) => {
  state.configs.data = payload.data;
  state.configs.loading = !!payload.loading;
};

// 首页配置数据(接口数据)
export const setWebsiteHomePublishConfigs: Mutation<IModuleState> = (state, payload) => {
  state.publishConfigs.data = payload.data;
  state.publishConfigs.loading = !!payload.loading;
};

// 首页配置数据(表单数据)
export const setWebsiteHomePageConfigs: Mutation<IModuleState> = (state, payload) => {
  const list = Array.isArray(payload) ? payload : [];
  state.pageConfigs = list.map((item, i) => ({ ...item, sortNo: i }));
};

// 设置选中的模块配置
export const setWebsiteHomeActiveConfig: Mutation<IModuleState> = (state, payload) => {
  if (typeof payload === 'number') {
    const len = state.pageConfigs.length;
    const index = Math.max(0, Math.min(payload, len - 1));
    state.activeConfig = state.pageConfigs.filter((item, i) => i === index)[0];
  } else {
    state.activeConfig = payload;
  }
};

// 设置复制的模块配置
export const setWebsiteHomeCopiedConfig: Mutation<IModuleState> = (state, payload) => {
  state.copiedConfig = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
